import { UiStage } from '@xbcb/ui-types';
import { DocumentExtractService } from './documentExtractService';
import { MockDocumentExtractService } from './mockDocumentExtractService';
import { isProject42Enabled } from '../../../featureFlags/index';

/**
 * Get the right document extract service based on the UI context.
 * @param {UiStage} stage The UI stage currently running.
 * @param {string} shipper The shipper account ID of the current session.
 * @return {DocumentExtractService} The appropriate document extract service.
 */
export const getDocumentExtractService = (
  stage: UiStage,
  shipper: string,
): DocumentExtractService => {
  if (
    isProject42Enabled({
      stage,
      shipperId: shipper,
    })
  ) {
    return new MockDocumentExtractService();
  } else {
    throw new Error(
      `Could not determine appropriate document extract service for stage: ${stage} and shipper: ${shipper}`,
    );
  }
};
